<template>
  <div>
    <el-form
      class="login-form form-custom"
      ref="form"
      label-position="top"
      label-width="80px"
      @submit.native.prevent
      :hide-required-asterisk="true"
      :rules="rules"
      :model="form"
    >
      <!-- 表单 -->
      <el-row :class="{ fr: $i18n.locale === 'cn' }" :gutter="12">
        <el-col :span="12">
          <!-- 名 -->
          <el-form-item
            class="form-item-primary"
            prop="firstName"
            :class="{ 'higher-height': $i18n.locale === 'en' }"
          >
            <BaseInput
              :autofocus="$i18n.locale === 'en' && !isMobile"
              :tabIndexNum="$i18n.locale === 'en' ? '1' : '2'"
              v-model="form.firstName"
              @blur="nameFilter('firstName')"
              :validate-event="Boolean(form.firstName)"
              :placeholer="$t('login.register.firstName')"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <!-- 姓 -->
          <el-form-item
            class="form-item-primary"
            prop="lastName"
            :class="{ 'higher-height': $i18n.locale === 'en' }"
          >
            <BaseInput
              :autofocus="$i18n.locale === 'cn' && !isMobile"
              :tabIndexNum="$i18n.locale === 'en' ? '2' : '1'"
              v-model="form.lastName"
              @blur="nameFilter('lastName')"
              :validate-event="Boolean(form.lastName)"
              :placeholer="'Family Name'"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item class="form-item-primary" prop="email">
        <!-- 邮箱 -->
        <BaseInput
          v-model.trim="form.email"
          :disabled="fromPlatform || fromGuest"
          :tabIndexNum="'3'"
          :validate-event="Boolean(form.email)"
          :placeholer="$t('login.register.enterYourEmail')"
        />
      </el-form-item>
      <el-form-item
        class="form-item-primary"
        prop="verification_code"
        :class="{ 'higher-height': $i18n.locale === 'en' }"
      >
        <!-- 验证码 -->
        <BaseInput
          v-model="form.verification_code"
          :maxlength="4"
          @focus="changeCode"
          :validate-event="Boolean(form.verification_code)"
          :placeholer="$t('login.resetPassword.verificationCode')"
        >
          <template #btn>
            <VerificationCode
              theme="primary"
              tip="Click here"
              ref="verification"
              @click="sendCode"
              :account="form.email"
              :from="'reset'"
            />
          </template>
          <template #prefix>{{
            $t('login.resetPassword.verificationCode')
          }}</template>
        </BaseInput>
      </el-form-item>
      <el-form-item
        class="form-item-primary"
        prop="password"
        :class="{ 'higher-height': $i18n.locale === 'en' }"
      >
        <!-- 密码 -->
        <BaseInput
          v-model.trim="form.password"
          type="password"
          @keyup.native="pwdFilter"
          @keyup.enter.native="submit"
          :validate-event="Boolean(form.password)"
          :placeholer="$t('login.register.setANewPassword')"
          :tabIndexNum="'4'"
        />
      </el-form-item>
    </el-form>

    <!-- 协议及订阅 -->
    <template v-if="hasAgreement">
      <Agreement v-model="form.agreement" />
    </template>

    <el-button
      class="button-custom"
      tabindex="5"
      @click="submit"
      v-track="{
        type: 'click',
        name: `${$route.params.type || 'phone'}.${
          $route.params.step || 'account'
        }.${fromEvent ? 'enterEvent' : 'registerUser'}`,
      }"
      >{{ detailSubmitText }}</el-button
    >

    <!-- 第三方登录 -->
    <template v-if="hasOtherLogin">
      <!-- <BaseLine :text="$t('login.register.or')" /> -->
      <OtherLogin />
    </template>
  </div>
</template>

<script>
import BaseMixin from '@/mixins/BaseMixin'
import RegisterStepDetailMixin from '../mixins/RegisterStepDetailMixin'
import { checkPassword } from '@/utils/validate-rules'
import VerificationCode from '@/components/login/VerificationCode.vue'
import store from '@/store'
import { checkPorscheEmail } from '../../valid'
export default {
  name: '',
  props: {},
  mixins: [BaseMixin, RegisterStepDetailMixin],
  data() {
    return {
      form: {
        email: '',
        verification_code: '',
      },
      registeredEmail: '',
    }
  },

  components: {
    VerificationCode,
  },

  computed: {
    passAccount() {
      return checkPorscheEmail(this.currentAccount)
    },
    submitDisabled() {
      let _disabled = false
      let arr = [
        'email',
        'firstName',
        'lastName',
        'password',
        'verification_code',
      ]
      arr.forEach((key) => {
        if (!this.form[key]) {
          _disabled = true
        }
      })
      return _disabled
    },
    rules() {
      return {
        email: [
          {
            required: true,
            message: this.$t('login.register.inputEmail'),
            trigger: 'blur',
          },
          {
            validator: async (rule, value, callback) => {
              // 已知已注册号码不再提交请求进行多次校验
              this.hasChangeEmail()
              if (this.registeredEmail)
                return callback(new Error(this.$t('login.register.exists')))

              if (checkPorscheEmail(value.toLowerCase())) {
                // 检测是否注册
                try {
                  let data = await store.dispatch('CheckUser', {
                    user_name: value,
                  })
                  if (data.data === false) {
                    // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                    this.registeredEmail = value
                    return callback(new Error(this.$t('login.register.exists')))
                  } else {
                    return callback()
                  }
                } catch (error) {
                  return callback()
                }
              }
              return callback(
                new Error('Please enter the correct E-mail address')
              )
            },
            trigger: 'blur',
          },
        ],
        lastName: [
          {
            required: true,
            message: this.$t('login.email.register.ruleLastName'),
          },
        ],
        firstName: [
          {
            required: true,
            message: this.$t('login.email.register.ruleFirstName'),
          },
        ],
        password: [
          {
            required: true,
            message: this.$t('login.email.register.setPassPop'),
          },
          {
            validator: (rule, value, callback) => {
              if (!checkPassword(value)) {
                callback(
                  new Error(this.$t('login.email.register.showPasswordRules'))
                )
              } else {
                callback()
              }
            },
            trigger: 'blur',
          },
        ],
        verification_code: [
          {
            required: true,
            message: this.$t('login.resetPassword.labelCode'),
          },
          {
            min: 4,
            message: this.$t('login.resetPassword.labelCode'),
          },
          {
            validator: (rule, value, callback) => {
              if (this.isWrong) {
                callback(new Error('Verification code'))
              } else {
                callback()
              }
            },
          },
        ],
      }
    },
  },

  methods: {
    changeCode() {
      this.isWrong = false
    },
    sendCode() {
      this.$refs['form'].validateField('email', (vaild) => {
        if (!vaild) {
          // if (isNeedHandleSMSActive()) {
          //   this.$store.commit('SET_SMSISACTIVE', false)
          // }
          this.$refs['verification'].send()
        }
      })
    },
    // 修改邮箱
    hasChangeEmail() {
      if (this.form.email !== this.registeredEmail) this.registeredEmail = ''
    },
    creatParams() {
      console.log(this.form)
      const { verification_code, email, password, firstName, lastName } =
        this.form
      return {
        email,
        password,
        firstName,
        lastName,
        verification_code,
        source: 'cim',
      }
    },

    async fetchRegisterData(params) {
      return await store.dispatch('RegisterByEmail', params)
    },
  },
}
</script>
<style lang="scss" scoped>
.button-custom {
  margin-top: 8px;
}

.form-custom {
  margin-top: 40px;
  margin-bottom: 40px;
}

.mgb-more {
  margin-bottom: 104px;
}
</style>
